const CustomerBillingStatusEnum = {
    Current: 'Current',
    Delinquent: 'Delinquent',
    Inactive: 'Inactive',
}

export default CustomerBillingStatusEnum;